import { SxProps, Theme, useMediaQuery } from '@mui/material'
import Typography from '@mui/material/Typography'
import PlusIcon from '../../../icons/plusIcon'
interface Props {
  handleClick?: () => void
  sx?: SxProps<Theme>
}
const AddButton = ({ handleClick, sx }: Props) => {
  const isSmallMobile = useMediaQuery('(max-width: 480px)')
  const isMobile = useMediaQuery('(max-width: 800px)')
  
  return (
    <Typography
      component='button'
      type='button'
      sx={{
        py: isSmallMobile ? '20px' : isMobile ? '25px' : '30px',
        display: 'flex',
        gap: isSmallMobile ? '10px' : '15px',
        alignItems: 'center',
        border: '2px solid #444D4E',
        width: '100%',
        justifyContent: 'center',
        backgroundColor: 'white',
        textTransform: 'uppercase',
        cursor: 'pointer',
        fontWeight: '700',
        fontSize: isSmallMobile ? '12px' : isMobile ? '13px' : '14px',
        lineHeight: isSmallMobile ? '16px' : '18px',
        ...sx,
      }}
      onClick={handleClick}
    >
      <PlusIcon />
      {<span>Ajouter un contact</span>}
    </Typography>
  )
}

export default AddButton
